<!-- 登录弹窗 -->
<template>
	<div>
		<!-- 登录表单 -->
		<el-dialog width="420px" :modal-append-to-body='false' :show-close='isShowCloseBtn' :modal='isShowCloseBtn' :close-on-click-modal="false" :visible="isShow" :before-close="loginDialogClose">
			<el-tabs v-loading="wxLoginLoading" v-model="activeName" @tab-click="tabClick">
				<el-tab-pane label="微信登录" name="wxLogin" class="wechat-login-wrapper">
					<!-- 微信登录——扫码 -->
					<div v-if="!isWxLogined" style="margin: 10px 0;">
						<div class="qrcode-tip"> <img src="../../assets/images/icon-wx.svg" /> 微信扫码，快速登录/注册</div>
						<div class="qrcode-container" id="login_container" ref="loginContainer"> </div>
					</div>

					<!-- 微信登录——注册 -->
					<div v-else-if="wxLoginType == 'needRigester'">
						<div class="text-align_l">第一次扫码需绑定手机号</div>
						<div class="login-item">
							<el-input v-model="loginTelOfWx" onkeyup="value=value.replace(/[^\d]/g,'')" @change='telInputChange()' placeholder="请输入手机号"></el-input>
						</div>
						<div class="login-item" style="margin-bottom:40px">
							<el-input class="input-vcode" :disabled='isNeedWaitVerificationCode' v-model="loginCode" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码"></el-input>
							<el-button class="btn-vcode" type="danger" @click="getVerificationCode">{{vcodeBtnTxt}}</el-button>
						</div>
						<div class="login-item" style="margin-bottom:unset">
							<el-button class="btn-login" type="danger" @click="loginCheck">登 录</el-button>
							<div class="qrcode_refresh" @click="refreshQrcode"> 重新扫码 </div>
						</div>
					</div>

					<!-- 微信登录——选择账号 -->
					<div v-else-if="wxLoginType == 'needSelect'">
						<div class="text-align_l">请选择你要登录的账号</div>
						<div class="login-item">
							<el-select :value="wxLoginSelectedUserInfo.customerId" placeholder="请选择" @change='wxUserSelected'>
								<el-option v-for="item in wxUserInfoList" :key="item.customerId" :label="item.nickName" :value="item.customerId">
								</el-option>
							</el-select>

							<div class="wx-user bg_gray">
								<div class="user-headimg">
									<img :src="wxLoginSelectedUserInfo.headImg" />
								</div>
								<div class="user-info">
									<div>{{wxLoginSelectedUserInfo.nickName}}</div>
									<div style="color: #9D9D9E;margin-top: 2px;">{{wxLoginSelectedUserInfo.vipLevelName}}</div>
								</div>
								<div v-if="wxLoginSelectedUserInfo.isLast" class="user-last">
									最近登录
								</div>
							</div>
						</div>

						<div class="login-item" style="margin-bottom:unset">
							<el-button class="btn-login" type="danger" @click="wxSelectedUserLogin">登 录</el-button>
							<div class="qrcode_refresh" @click="refreshQrcode"> 重新扫码 </div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="密码登录" name="pwdLogin" class="login-box">
					<div class="login-item">
						<el-input v-model="loginName" placeholder="请输入用户名"></el-input>
					</div>
					<div class="login-item">
						<el-input v-model="loginPwd" minlength="6" placeholder="请输入密码" show-password></el-input>
						<div style="display: flex;justify-content: space-between;">
							<el-button class="login-pwd_tip" type="text" @click="toRegister">注册账号 </el-button>
							<el-button class="login-pwd_tip" type="text" @click="forgetPwd">忘记密码？</el-button>
						</div>
					</div>
					<div class="login-item">
						<el-button class="btn-login" type="danger" @click="loginByPwd" :loading="loginClicked">登 录</el-button>
					</div>
				</el-tab-pane>

				<el-tab-pane label="短信登录" name="telLogin" class="login-box">
					<div class="login-item">
						<el-input v-model="loginTelOfNormal" onkeyup="value=value.replace(/[^\d]/g,'')" @change='telInputChange()' placeholder="请输入手机号"></el-input>
					</div>
					<div class="login-item">
						<el-input class="input-vcode" :disabled='isNeedWaitVerificationCode' v-model="loginCode" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码"></el-input>
						<el-button class="btn-vcode" type="danger" @click="getVerificationCode">{{vcodeBtnTxt}}</el-button>
						<div style="line-height: 40px;color: #A5A6AE;">
							*未注册手机号验证后，自动注册登录
						</div>
					</div>
					<div class="login-item">
						<el-button class="btn-login" type="danger" @click="loginCheck" :loading="loginClicked">{{forgetClicked?"确 定":"登 录"}}</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 忘记密码弹窗 产品要求 忘记密码 单独弹窗-->
		<el-dialog :destroy-on-close="true" width="420px" :modal-append-to-body='false' :close-on-click-modal="false" :visible="forgetClicked" :before-close="forgetDialogClose">
			<div class="login-box">
				<div class="login-item" style="text-align: center;font-size: 28px;margin-bottom: 45px;">
					忘记密码
				</div>
				<div class="login-item">
					<el-input v-model="loginTelOfForget" onkeyup="value=value.replace(/[^\d]/g,'')" @change='telInputChange(true)' placeholder="请输入手机号"></el-input>
				</div>
				<div class="login-item" style="margin-bottom: 40px;">
					<el-input class="input-vcode" :disabled='isNeedWaitVerificationCode' v-model="loginCode" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码"></el-input>
					<el-button class="btn-vcode" type="danger" @click="getVerificationCode">{{vcodeBtnTxt}}</el-button>
				</div>
				<div class="login-item">
					<el-button class="btn-login" type="danger" @click="loginCheck" :loading="loginClicked">{{forgetClicked?"确 定":"登 录"}}</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 完善用户名密码信息弹窗 -->
		<name-pwd-dialog :isShow="showCompleteInfo" :oldName="oldLoginName" :tel="loginTel" @success="completeSuccess"></name-pwd-dialog>
	</div>
</template>

<script>
	import NamePwdDialog from './NamePwdDialog.vue';
	import CheckInApply from '../../components/common/CheckInApply.vue';
	import { getCustomerInfo, registeCustomer, getWxLoginInfo, updateCusPcOpenId } from '../../utils/api-utils/api-customer.js';
	import { getParam } from '../../utils/api-utils/api-params.js';
	import commonUtil from '../../utils/common-utlis.js';
	import { system } from '../../utils/api-utils/api-sys.js';
	var interval;
	export default {
		name: 'login-dialog',
		components: {
			'name-pwd-dialog': NamePwdDialog,
			'checkin-apply': CheckInApply,
		},
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			showClose: {
				type: Boolean,
				default: true
			}, // 是否强制登录，前人命名有歧义
			isShowCloseBtn: {
				type: Boolean,
				default: true
			}, // 是否显示关闭按钮
		},
		data() {
			return {
				dialogVisible: false, // 是否显示登录弹窗
				loginTel: "", // 用户输入的手机号
				loginTelOfWx: "", // 用户输入的手机号
				loginTelOfNormal: "", // 用户输入的手机号
				loginTelOfForget: '', // 用户输入的手机号
				loginCode: "", // 用户输入的验证码
				sysLoginCode: "66991", // 系统发送的验证码，用作校验
				vcodeBtnTxt: "获取验证码", // 获取验证码按钮文字
				vcodeIntervalTime: 60, // 验证码发送间隔 
				loginClicked: false, // 按钮已点击
				loginType: "pwd", // 登录方式 tel:手机号验证码, pwd:登录名密码
				loginName: "", //登录名
				loginPwd: "", //登录密码
				showCompleteInfo: false, //完善信息弹窗（用户名密码）
				forgetClicked: false, //点击了忘记密码
				oldLoginName: "", //原登录名
				customerInfo: {},
				activeName: 'wxLogin', // 当前tab
				wxLoginLoading: true, // 微信登录二维码是否加载完成
				isWxLogined: false, // 是否完成扫码登录
				isNeedRigester: true, // 是否需要注册
				wxUserInfoList: [], // 根据微信code匹配的用户信息list
				wxLoginSelectedUserInfo: {}, // 当前选中的用户信息
				isNeedWaitVerificationCode: false, // 是否需要等待验证码
				tabOfGetVerificationCode: '', // 发起验证码请求的tab
			}
		},
		created: function() {
			this.loadParam(); // 获取参数
		},
		mounted() {
			this.initWxLogin();

			//监听扫码登录回调
			this.$eventBus.$on("setWxLoginCode", this.setupPostMessageListener)
		},
		beforeDestroy() {
			// 移除监听
			this.$eventBus.$off('setWxLoginCode', this.setupPostMessageListener);
		},
		methods: {
			/**
			 * 加载参数
			 */
			async loadParam() {
				let params = await getParam("pc_restrictLoginText,isOpenLoginLimit,loginLimitType");
				if (!!params.pc_restrictLoginText) {
					this.restrictLoginText = params.pc_restrictLoginText.replaceAll('\n', '<br>');
				}
				this.isOpenLoginLimit = params.isOpenLoginLimit == '1';
				this.loginLimitType = params.loginLimitType;
			},

			/**
			 * 加载微信登录二维码
			 */
			initWxLogin() {
				if (!this.$refs.loginContainer) {
					setTimeout(() => {
						this.initWxLogin()
					}, 1)
					return
				}

				// 清空旧内容（包括 iframe）
				this.$refs.loginContainer.innerHTML = '';

				this.wxLogin = new WxLogin({
					self_redirect: true,
					id: "login_container",
					appid: "wx20c6252dde615b7f",
					scope: "snsapi_login",
					redirect_uri: encodeURIComponent('https://jmall.jackyun.com/WechatPlatform_Test/api/wechatplatform/GetWxLoginCode'),
					fast_login: 1,
					stylelite: 1,

					onReady: (isReady) => {
						this.wxLoginLoading = !isReady
					}
				});
			},

			/**
			 * 微信登录回调监听
			 */
			async setupPostMessageListener(wxLoginCode) {
				this.wxLoginLoading = true;
				// 根据code获取用户信息
				let wxLoginResult = await getWxLoginInfo(wxLoginCode);

				this.wxLoginLoading = false;
				this.isWxLogined = true
				this.wxUserInfoList = wxLoginResult.wxUserInfoList;
				this.wxLoginType = this.getWxLoginType()
				this.isNeedRigester = !this.wxUserInfoList || this.wxUserInfoList.length == 0
				this.pcOpenId = wxLoginResult.pcOpenId
				this.wxLoginSelectedUserInfo = this.wxUserInfoList.find(item => item.isLast) || this.wxUserInfoList[0] || {};

				// 若 OpenID仅关联一个吉商城手机号 直接登录
				this.wxUserInfoList.length == 1 && this.wxSelectedUserLogin()
			},

			/**
			 * 微信扫码登 选择账号登录
			 */
			getWxLoginType() {
				switch (this.wxUserInfoList.length) {
					case 0:
						return 'needRigester'
						break;
					case 1:
						return 'needLogin'
						break;
					default:
						return 'needSelect'
						break;
				}
			},

			/**
			 * 微信扫码登 选择账号登录
			 */
			async wxSelectedUserLogin() {
				if (this.loginClicked) {
					return this.$message.error('请勿重复点击');
				}
				this.loginClicked = true;
				// 显示加载中弹窗
				commonUtil.showLoading(this, '登录中');

				// 清除customerid缓存
				localStorage.removeItem("pc_customerId");
				localStorage.removeItem("pc_lastLoginDistributorId");

				//用户名密码登录
				let loginParams = { distributorId: this.wxLoginSelectedUserInfo.distributorId }
				let customer = await getCustomerInfo(loginParams, true)
				this.loginClicked = false;
				// 关闭加载中弹窗
				commonUtil.closeLoading();

				// 登录失败
				if (!customer.phone || customer.error) {
					// 刷新登录二维码
					this.refreshQrcode()

					// 是否需要展示 申请表单
					let needHandleLoginLimit = customer.error && customer.error.includes("需要申请") && this.isOpenLoginLimit && ['auditLimitOfCheckIn', 'auditLimitOfPrice', 'auditLimitOfPersonalInfo'].includes(this.loginLimitType);

					return needHandleLoginLimit ? this.handleLoginLimit(loginParams) : this.$message.error(customer.errorTip || customer.error);
				}

				// 刷新当前页面
				this.customerInfo = customer
				this.completeSuccess();
			},

			/**
			 * 微信账号选择
			 */
			wxUserSelected(curCustomerId) {
				this.wxLoginSelectedUserInfo = this.wxUserInfoList.find(item => item.customerId == curCustomerId)
			},

			/**
			 * 刷新微信登录二维码
			 */
			refreshQrcode() {
				this.isWxLogined = false
				this.initWxLogin()
			},

			/**
			 * 手机号输入
			 */
			telInputChange(isFromForget = false) {
				this.loginTel = isFromForget ? this.loginTelOfForget : this.activeName == 'wxLogin' ? this.loginTelOfWx : this.loginTelOfNormal;
			},

			/**
			 * tab切换
			 */
			tabClick() {
				this.loginTel = this.activeName == 'wxLogin' ? this.loginTelOfWx : this.loginTelOfNormal;
				this.loginCode = '';
				this.loginClicked = false;
				this.isNeedWaitVerificationCode = this.vcodeBtnTxt != "获取验证码" && (this.tabOfGetVerificationCode != this.activeName)
			},

			/**
			 * 弹窗关闭事件
			 */
			loginDialogClose() {
				//强制登录的页面，关闭时回到首页
				if (!this.showClose && this.$route.name == "home") {
					location.reload();
				} else if (!this.showClose) {
					this.$router.push({
						name: 'home'
					})
				}

				// 弹窗关闭时调用父级传递方法close内容，将关闭信息传递到父级
				this.$emit('close', { isJustClose: true });

				// 重置忘记密码操作
				this.forgetClicked = false;
			},

			/**
			 * 获取验证码
			 */
			getVerificationCode() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测是否可以再次获取验证码
				if (_this.vcodeBtnTxt != "获取验证码") {
					return false;
				}

				// 检测验证码输入是否正确
				if (!_this.loginTel) {
					return _this.$message.error('请输入手机号');
				}

				// 检测手机号格式是否正确
				if (!_this.$utils.checkTel(_this.loginTel)) {
					return _this.$message.error('手机号格式不正确');
				}

				// 发送请求获取验证码
				_this.$request.jackyunPost({
					method: "jmall.sms.sendverificationcode",
					jsonStr: JSON.stringify({
						loginTel: _this.loginTel,
					})
				}, (data) => {

					// 检测验证码发送是否正确
					if (data.code != 200) {
						return _this.$message.error(data.msg);
					}
					// 正确情况记录验证码，用作前端校验
					_this.getSysLoginCode = true;
					_this.tabOfGetVerificationCode = this.forgetClicked ? 'forgetTab' : this.activeName;

					// 开始倒计时
					_this.countdown();

				});
			},
			/**
			 * 校验验证码
			 */
			checkVerificationCode() {
				let _this = this;
				return new Promise((resolve, reject) => {
					// 发送请求获取验证码
					_this.$request.jackyunPost({
						method: "jmall.sms.checkverificationcode",
						jsonStr: JSON.stringify({
							loginTel: _this.loginTel,
							verificationCode: _this.loginCode
						})
					}, (data) => {
						// 检测验证码发送是否正确
						if (data.code != 200) {
							return resolve(false);
						} else {
							return resolve(true);
						}

					});
				})
			},

			/**
			 * 倒计时
			 */
			countdown() {
				let _this = this;
				interval = setInterval(function() {
					_this.vcodeBtnTxt = _this.vcodeIntervalTime + "秒";
					_this.vcodeIntervalTime = _this.vcodeIntervalTime - 1;
					if (_this.vcodeIntervalTime < 0) {
						_this.vcodeBtnTxt = "获取验证码";
						_this.vcodeIntervalTime = 60;
						_this.isNeedWaitVerificationCode = false;
						clearInterval(interval);
					}
				}, 1000);
			},

			/**
			 * 登录验证
			 */
			async loginCheck() {
				let _this = this;
				//关闭所有警告
				_this.$message.closeAll();

				// 检测手机号是否输入
				if (!_this.loginTel) {
					return _this.$message.error('请输入手机号');
				}

				// 检测手机号格式是否正确
				if (!_this.$utils.checkTel(_this.loginTel)) {
					return _this.$message.error('手机号格式不正确');
				}

				// 检测验证码输入是否正确
				if (!_this.loginCode) {
					return _this.$message.error('请输入验证码');
				}

				//检测验证码是否已经获取
				if (!_this.getSysLoginCode) {
					return _this.$message.error('请获取验证码');
				}
				// if (!await _this.checkVerificationCode()) {
				// 	return _this.$message.error('验证码不正确');
				// }

				// 检测验证码是否填写正确
				// if (_this.loginCode != _this.sysLoginCode) {
				// 	return _this.$message.error('验证码不正确');
				// }

				_this._getCustomerInfoByTel();
			},

			/**
			 * 获取用户信息
			 */
			async _getCustomerInfoByTel() {
				let _this = this;
				if (_this.loginClicked) {
					return _this.$message.error('请勿重复点击');
				}
				_this.loginClicked = true;
				// 显示加载中弹窗
				commonUtil.showLoading(this, '登录中');

				// 清除customerid缓存
				localStorage.removeItem("pc_customerId");
				localStorage.removeItem("pc_lastLoginDistributorId");

				// 手机号登录
				let loginParams = { tel: _this.loginTel, verificationCode: _this.loginCode }
				let customer = await getCustomerInfo(loginParams, true);

				// 是否需要注册
				let needRegister = customer.error && (customer.error.includes("根据手机号未查到客户信息") || customer.error.includes("未获取到crm客户档案"));
				// 是否需要展示申请
				let needHandleLoginLimit = _this.isOpenLoginLimit && ['auditLimitOfCheckIn', 'auditLimitOfPrice', 'auditLimitOfPersonalInfo'].includes(_this.loginLimitType);
				customer = needRegister ? await registeCustomer(this.loginTel, needHandleLoginLimit) : customer;

				// 关闭加载中弹窗
				_this.loginClicked = false;
				commonUtil.closeLoading();

				// 登录失败
				if (!customer.phone || customer.error) {
					// 刷新登录二维码
					this.refreshQrcode()

					return customer.error.includes('需要申请') && needHandleLoginLimit ? _this.handleLoginLimit(loginParams) : _this.$message.error(customer.errorTip || customer.error);
				}

				// 关联pcopenid
				this.bindPcOpenIdForCustomer(customer)

				// 判断是否有用户名密码，没有的话，提示设置（忘记密码也需要弹窗重置）
				if (!customer.loginName || this.forgetClicked) {
					this.customerInfo = customer
					this.oldLoginName = this.forgetClicked ? (customer.loginName || "") : '';
					this.showCompleteInfo = true;
					this.forgetClicked = false;
				} else {
					this.customerInfo = customer
					_this.completeSuccess();
				}
			},

			/**
			 * 绑定pcopenid
			 */
			bindPcOpenIdForCustomer(customer) {
				if (this.activeName != 'wxLogin' || !this.pcOpenId || !customer.distributorId) return

				updateCusPcOpenId(this.pcOpenId, customer.distributorId)
			},

			/**
			 * 前往表单申请界面
			 */
			handleLoginLimit(loginParams = {}) {
				localStorage.removeItem("pcOpenIdForRegister")
				this.activeName == 'wxLogin' && localStorage.setItem("pcOpenIdForRegister", this.pcOpenId);
				// 记录手机号
				localStorage.setItem("telForRegister", this.loginTel);
				localStorage.setItem("loginParams", JSON.stringify(loginParams));

				this.$emit('close', {isNeedShowApplyForm: true});
			},

			/**
			 * 用户名密码登录
			 */
			loginByPwd() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测用户名是否输入
				if (!_this.loginName) {
					return _this.$message.error('请输入用户名');
				}

				// 检测密码是否输入
				if (!_this.loginPwd) {
					return _this.$message.error('请输入密码');
				}

				// 检测密码是否输入
				// if (_this.loginPwd.length < 6) {
				// 	return _this.$message.error('请至少输入6位数密码');
				// }

				// 获取用户信息
				_this.getCustomerByPwd();
			},

			/**
			 * 根据用户名密码，获取用户信息
			 */
			async getCustomerByPwd() {
				let _this = this;
				if (_this.loginClicked) {
					return _this.$message.error('请勿重复点击');
				}
				_this.loginClicked = true;
				// 显示加载中弹窗
				commonUtil.showLoading(this, '登录中');


				// 清除customerid缓存
				localStorage.removeItem("pc_customerId");
				localStorage.removeItem("pc_lastLoginDistributorId");

				//用户名密码登录
				let loginParams = { loginName: _this.loginName, loginPwd: btoa(encodeURIComponent(_this.loginPwd)) }
				let customer = await getCustomerInfo(loginParams, true)

				// 关闭加载中弹窗
				_this.loginClicked = false;
				commonUtil.closeLoading();

				// 登录失败
				if (!customer.phone || customer.error) {
					// 是否需要展示 申请表单
					let needHandleLoginLimit = customer.error.includes("需要申请") && _this.isOpenLoginLimit && ['auditLimitOfCheckIn', 'auditLimitOfPrice', 'auditLimitOfPersonalInfo'].includes(_this.loginLimitType);

					return needHandleLoginLimit ? _this.handleLoginLimit(loginParams) : _this.$message.error(customer.errorTip || customer.error);
				}

				// 刷新当前页面
				this.customerInfo = customer
				_this.completeSuccess();
			},

			/**
			 * 用户名密码设置完成
			 */
			completeSuccess() {
				// 获取用户信息
				this.showCompleteInfo = false;
				this.$emit('close', { isLoginSuccess: true });
				// location.reload();

				system.setCustomerId(this.customerInfo.customerId)

				const channel = new BroadcastChannel("jmall-memberName");
				channel.postMessage(this.customerInfo.customerId);
				channel.close();
			},

			/**
			 * 忘记密码（先用手机号登录，再设置密码）
			 */
			forgetPwd() {
				// this.activeName = 'telLogin';
				this.loginTel = '';
				this.loginTelOfForget = '';
				this.loginCode = '';
				this.forgetClicked = true;
				this.isNeedWaitVerificationCode = this.vcodeBtnTxt != "获取验证码" && (this.tabOfGetVerificationCode != 'forgetTab')
			},
			forgetDialogClose() {
				this.loginTel = '';
				this.loginCode = '';
				this.forgetClicked = false;
			},

			/**
			 * 注册账号
			 */
			toRegister() {
				this.activeName = 'telLogin';
			}

		}
	}
</script>

<style scoped="scoped">
	.login-box {
		padding: 20px 50px;
	}

	.login-title {
		text-align: center;
		font-size: 26px;
		margin-bottom: 50px;
	}

	.login-item {
		margin-bottom: 20px;
	}

	.input-vcode {
		width: calc(100% - 123px) !important;
	}

	.btn-vcode {
		margin-left: 10px;
		width: 112px;
	}

	.btn-login {
		width: 100%;
	}

	.btn-change-type {
		border: 1px solid #f56c6c;
		color: #f56c6c;
	}

	.skeleton-placeholder {
		height: 100%;
	}

	.wechat-login-wrapper {
		width: 300px;
		position: relative;
		min-height: 260px;
		padding: 20px 0;
	}

	.qrcode-tip {
		text-align: center;
		margin-bottom: 20px;
		color: black;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.qrcode-tip img {
		width: 24px;
		margin-right: 10px;
	}

	.qrcode-container {
		width: 100%;
		height: 100%;
	}

	.el-tab-pane {
		margin: 0 auto;
	}

	.text-align_l {
		text-align: left;
		margin-bottom: 15px;
		color: black;
	}

	.bg_gray {
		background-color: #F3F3F3;
	}

	.wx-user {
		margin-top: 10px;
		padding: 15px 0;
		display: flex;
		align-items: center;
		overflow: hidden;
		position: relative;
		height: 35px;
	}

	.user-headimg {
		margin-left: 20px;
		width: 40px;
		height: 40px;
		border: 2px solid white;
		border-radius: 50%;
	}

	.user-headimg img {
		width: 100%;
	}

	.user-info {
		margin-left: 13px;
	}

	.user-last {
		border-radius: 11px 0;
		background-color: #F56C6C;
		position: absolute;
		top: 0;
		right: 0;
		padding: 0 10px;
		color: white;
		font-size: 11px;
		line-height: 20px;
	}

	.qrcode_refresh {
		text-align: center;
		margin-top: 10px;
		cursor: pointer;
		color: #576b95;
	}

	#login_container {
		height: 200px !important;
	}

	/deep/.el-select {
		width: 100%;
	}

	/deep/.el-tabs__nav-wrap::after {
		display: none;
	}

	/deep/.el-tabs__nav {
		left: 50%;
		transform: translateX(-50%) !important;
		width: fit-content;
	}

	/deep/.el-tabs__item {
		font-size: 16px !important;
		padding: 0 25px !important;
		margin-bottom: 0px !important;
	}

	.login-pwd_tip {
		color: #666666;
		font-weight: normal;
	}

	.login-pwd_tip:hover {
		color: #ff5757;
	}
</style>